<div class="w-full h-full flex flex-col items-center justify-start py-8 gap-4">
    <div
        class="text-white flex flex-col items-center justify-center w-full header-container"
    >
        <h1 class="flex text-2xl">ZevoTech TTS Self-Service</h1>
        <h3 class="flex text-center">
            Generate realistic sounding speech with different identities.
        </h3>
    </div>
    <div class="bg-white rounded-lg w-4/5 lg:h-2/3 min-h-fit flex flex-1">
        <form
            class="flex p-8 w-full h-full gap-4 lg:gap-8 flex-wrap lg:flex-nowrap"
            (submit)="onSubmitListener($event)"
            [formGroup]="ttsForm"
        >
            <div class="flex lg:basis-2/4 basis-full">
                <zt-textarea
                    [control]="textControl | formControl"
                ></zt-textarea>
            </div>
            <div class="flex flex-col grow">
                <div
                    class="controls-container flex flex-wrap gap-2 lg:gap-8 items-center"
                >
                    <zt-dropdown
                        [options]="languageOptions"
                        [config]="languageConfig"
                        [control]="languageControl | formControl"
                    ></zt-dropdown>
                    <zt-dropdown
                        [options]="voiceOptions"
                        [config]="voiceConfig"
                        [control]="voiceControl | formControl"
                    ></zt-dropdown>
                    <zt-slider
                        [config]="paceConfig"
                        [min]="0.5"
                        [max]="2.0"
                        [step]="0.1"
                        [control]="paceControl | formControl"
                    ></zt-slider>
                    <zt-slider
                        [config]="pitchConfig"
                        [min]="-300"
                        [max]="300"
                        [step]="100"
                        [control]="pitchControl | formControl"
                    ></zt-slider>
                    <div class="flex gap-4 btn-container">
                        <ng-template
                            [ngIf]="isPlayActive && !isFetchingAudio"
                            [ngIfElse]="playBtn"
                        >
                            <zt-button
                                *ngIf="isPlayActive && !isFetchingAudio"
                                [config]="stopBtnConfig"
                                [type]="ZtButtonType.SECONDARY"
                                (onClick)="onStopListener()"
                            ></zt-button>
                        </ng-template>
                        <ng-template #playBtn>
                            <zt-button
                                [loading]="isFetchingAudio"
                                [disabled]="!ttsForm.valid"
                                [config]="playBtnConfig"
                                [type]="ZtButtonType.PRIMARY"
                                (onClick)="onPlayListener()"
                            ></zt-button>
                        </ng-template>
                        <zt-button
                            *ngIf="isLoggedIn() && fileToDownload"
                            [config]="saveBtnConfig"
                            [type]="ZtButtonType.PRIMARY"
                            (onClick)="saveExecution()"
                        ></zt-button>
                        <zt-button
                            *ngIf="isLoggedIn() && fileToDownload"
                            [config]="downloadBtnConfig"
                            [type]="ZtButtonType.PRIMARY"
                            (onClick)="downloadAudioFile()"
                        ></zt-button>
                    </div>
                </div>
                <div class="flex flex-wrap gap-2 lg:gap-8 items-center mt-4">
                    <zt-toggle
                        [config]="streamingConfig"
                        [control]="ttsForm.get('streaming') | formControl"
                    ></zt-toggle>
                </div>
                <!-- TODO: uncomment this once the functionality for phonems and transliterals is desided -->
                <!-- <div
                    class="logged-controls flex flex-row gap-4"
                    *ngIf="isLoggedIn()"
                >
                    <zt-textarea
                        [config]="phonemsConfig"
                        [control]="phonemsControl | formControl"
                    ></zt-textarea>
                    <zt-textarea
                        [config]="transliteralsConfig"
                        [control]="transliteralsControl | formControl"
                    ></zt-textarea>
                </div> -->
                <div *ngIf="blob">
                    <zt-simple-waveform-viewer
                        [blob]="blob"
                        [stop]="!isPlayingAudio"
                        [play]="isPlayingAudio"
                        [showWaveform]="isPlayingAudio || isLoggedIn()"
                        [showControls]="isLoggedIn()"
                        (onFinish)="onFinishListener()"
                        (onPause)="onPauseListener()"
                    ></zt-simple-waveform-viewer>
                </div>
            </div>
        </form>
    </div>
</div>
